import axios from "axios";

import API_URL from "..";
import { API } from "../client";

const API_URL_TRANSACTION = API_URL + "transaction/";

const createTransaction = async (token, transaction) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.post(API_URL_TRANSACTION, transaction, config);

  return res.data;
};

const getTransaction = async (token, { id, query }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await API.get(
    API_URL_TRANSACTION +
      `/${id}?startDate=${query?.startDate}&endDate=${query?.endDate}&page=${query.page}&limit=${query.limit}`,
    config
  );

  return res.data;
};

const getTransactions = async (token, query) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await API.get(
    API_URL_TRANSACTION +
      `?startDate=${query?.startDate}&endDate=${query?.endDate}&page=${query.page}&limit=${query.limit}`,
    config
  );

  return res.data;
};

const getTransactionAnalytics = async (token, query) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await API.get(
    API_URL_TRANSACTION +
      `analytics?startDate=${query?.startDate}&endDate=${query?.endDate}`,
    config
  );

  return res.data;
};

const editTransaction = async (token, data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.put(
    API_URL_TRANSACTION + `/${data?.id}`,
    data,
    config
  );

  return res.data;
};

const getAgentsCredit = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await API.get(API_URL_TRANSACTION + `credit`, config);

  return res.data;
};

const transactionApi = {
  createTransaction,
  getTransaction,
  getTransactions,
  editTransaction,
  getAgentsCredit,
  getTransactionAnalytics,
};

export default transactionApi;
